import { gql } from '@apollo/client'

export const removeStorySetById = gql`
  mutation RemoveStorySetById($_id: String!) {
    storySetRemoveById(_id: $_id) {
      recordId
    }
  }
`
